import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css' // 如果要使用它的默认样式
const app = createApp(App)

// 2. 注册 ElementPlus 插件
app.use(ElementPlus)
app.use(store)
app.use(router)

app.mount('#app')
